export default __webpack_public_path__ + "static/media/il.05f26b7c.jpg";